import { Container, Divider } from "@material-ui/core";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import {
  CurrencyDisplay,
  CustomTable,
  ModalError,
  Page,
  SearchTextInput,
  SkeletonComponent,
  MonthYearRangePicker
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import { columnTableReport } from "../Components/ConstanstReport";

function DetailReport() {
  const classes = globalStyles();
  const { state } = useLocation();
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const [loadingPage, setLoadingPage] = useState(true);
  const [pageDetail, setPageDetail] = useState({});
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
    start_month: state?.startDate ? formatGetPeriodParams(state?.startDate) : moment(),
    end_month: state?.endDate ? formatGetPeriodParams(state?.endDate) : moment(),
    dsp_id: state?.dsp_id,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const { start_month, end_month, ...otherParams } = queryParams;

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/report/${id}`, {
        headers,
        params: {
          ...otherParams,
          start_month: formatParamsMonth(start_month),
          end_month: formatParamsMonth(end_month),
          year: formatParamsYear(start_month),
        },
      });
      const { data, meta } = res?.data;
      setPageDetail(data);
      const pageCount = getTotalPage(meta?.total, queryParams?.size || 1);
      setTableTotalPage(pageCount);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDetail = useCallback(
    debounce(() => {
      getDetail();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    const isSearching = queryParams?.search;
    if (isSearching) {
      debounceDetail();
      return () => {
        debounceDetail.cancel();
      };
    } else {
      getDetail();
    }
  }, [queryParams, debounceDetail]);

  return (
    <Page className={classes.root} title="Detail Report">
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false} id={"container-detail-report"}>
          <HeaderTitle
            title={`${pageDetail?.composer_name} Songs Report`}
            breadcrumbData={breadcrumbData}
            backButton
          />
          <Divider className={classes.divider} />
          <Grid container justifyContent="space-between" mb="16px">
            <Grid item>
              <SearchTextInput
                placeholder="Search"
                value={queryParams?.search}
                onChange={e =>
                  handleChangeQueryParams(e?.target?.value, "search")
                }
              />
            </Grid>
            <Grid item>
              <MonthYearRangePicker
                label="Period"
                startDate={queryParams?.start_month}
                handleChangeStartDate={date => handleChangeQueryParams(date, "start_month")}
                endDate={queryParams?.end_month}
                handleChangeEndDate={date => handleChangeQueryParams(date, "end_month")}
                syncYear
                width={250}
                disabled={loadingPage}
              />
            </Grid>
          </Grid>
          <CustomTable
            columnTable={columnTableReport({ isDetail: true })}
            data={pageDetail?.data}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
          />
          <Box borderRadius="5px" p="24px" bgcolor="#F9FAFB" my={2}>
            {MockFieldForm?.map(
              ({ title, key, subKey, divider, isTotal }, index) =>
                divider ? (
                  <Divider className={classes?.divider} key={index} />
                ) : (
                  <Grid container justifyContent="space-between" key={index}>
                    <Grid item>{`${title} ${
                      subKey ? `(${pageDetail?.[subKey]} %)` : ""
                    }`}</Grid>
                    <Grid item>
                      <CurrencyDisplay
                        decimalScale={2}
                        prefix="Rp"
                        value={pageDetail?.[key]}
                        fontWeight={isTotal ? 700 : 500}
                        fontSize={isTotal ? 20 : 18}
                      />
                    </Grid>
                  </Grid>
                )
            )}
          </Box>
        </Container>
      )}
    </Page>
  );
}

const formatParamsMonth = date => date.format("M");
const formatParamsYear = date => date.format("YYYY");
const formatGetPeriodParams = date => moment(date, "M-YYYY");
const breadcrumbData = [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "Report V2",
    link: "/admin/reports",
  },
  {
    label: "Detail Report",
    active: true,
  },
];
const MockFieldForm = [
  { title: "Total Composer Revenue", key: "composer_revenue" },
  { title: "WHT", key: "tax_deduction", subKey: "pph" },
  { divider: true },
  { title: "Grand Total", key: "grand_total", isTotal: true },
];

export default DetailReport;
